import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TITLE_OBJECT_TYPE_GROUP } from 'constants/Mapping.constants';
import intl from 'i18n/intl';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';
import AddNewObjectType from '../../../components/AppService/ObjectTypes/AddNewObjectTypes';
import ObjectTypeMapping from '../../../components/AppService/ObjectTypes/ObjectTypeMapping';
import {
  appServiceExamV3ObjectTypes,
  fetchExamV3Mapping,
  fetchRawObjectFields,
} from '../../../slices/appService.slice';
import './objectTypes.scss';

const language: any = intl.messages;

const { Text } = Typography;

const ObjectTypes = () => {
  const dispatch = useAppDispatch();
  // Store local copy of integration settings in component state
  const storeResource = useSelector(appServiceExamV3ObjectTypes);
  const [resource, setResource] = useState(storeResource);
  /**
   * EFFECTS
   */
  useEffect(() => {
    setResource(storeResource);
  }, [storeResource]);

  useEffect(() => {
    dispatch(fetchExamV3Mapping());
    dispatch(fetchRawObjectFields('teExamV3'));
  }, []);

  /**
   * EVENT HANDLERS
   */
  return (
    <DefaultContentLayout
      title={language.exam_v3_object_type_settings_title}
      subtitle={language.exam_v3_object_type_settings_sub_title}
    >
      <div
        className="inner-content--wrapper allow-scroll"
        style={{ padding: 15, display: 'block' }}
      >
        <AddNewObjectType
          appName={'teExamV3'}
          allowedMappingModes={['FREE_MAPPING']}
          objectTypes={resource}
        />
        <div className="object-type-mappings-header">
          <div className="object-type-mappings-header__label">
            <Text>Label</Text>
          </div>
          <div className="object-type-mappings-header__label">
            <Text>Property name</Text>
          </div>
          <div className="object-type-mappings-header__label">
            <Text>{TITLE_OBJECT_TYPE_GROUP}</Text>
          </div>
          <div className="object-type-mappings-header__label object-type-mappings-header__label--center">
            <Text>Status</Text>
          </div>
          <div className="object-type-mappings-header__label"></div>
        </div>
        {resource.map((objectType: any, objectTypeIdx: number) => (
          <ObjectTypeMapping
            key={objectType.objectTypeExtId + objectTypeIdx}
            objectType={objectType}
            appName={'teExamV3'}
            allowedMappingModes={['FREE_MAPPING']}
            objectTypeIdx={objectTypeIdx}
          />
        ))}
      </div>
    </DefaultContentLayout>
  );
};

export default ObjectTypes;
